import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getNumericValue} from '../../../../common/util/fieldsValidation';

class TotalValues extends Component {
  getOrdersSum(suggestedOrders = []) {
    return suggestedOrders.reduce((result, order) => {
      return result + parseInt(order.partQuantity || 0, 10);
    }, 0);
  }

  getOrdersFee(suggestedOrders = []) {
    const orderTotalFob = suggestedOrders.reduce((result, order) => {
      return result + Number(order.totalFob || 0.0);
    }, 0.0);

    return getNumericValue(orderTotalFob, 2);
  }

  render() {
    const {detail} = this.props;
    return (
      <span>
        <strong>Totales: </strong>
        cantidad de líneas: {detail.length},
        unidades del pedido: {this.getOrdersSum(detail)},
        FOB total: $ {this.getOrdersFee(detail)}
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'detail': state.providerManualOrder.detail,
  };
};

export default connect(mapStateToProps)(TotalValues);
